import React from 'react';
import VideoEmbed from '../VideoEmbed';
import { groupVideosByContentType } from '../../constants/videoContentTypes';
import { videoTag, videoTitle } from '../../lib/publicProfile';

export default function Highlights({ videos }) {
  if (!videos || videos.length === 0) return null;

  // The mock (Public Profile v2.dc.html) renders one continuous 2-column grid
  // over the whole video list, ordered game-film-first — not a separate grid
  // per content type. groupVideosByContentType exists to produce that order
  // ("Group by groupVideosByContentType as today" per the design README), so
  // its buckets are flattened back into a single list rather than each kept
  // in its own wrapper: a per-group wrapper would restart the 2-col grid at
  // every content-type boundary and strand an odd-numbered bucket's last card
  // alone in its own row instead of flowing beside the next bucket's first.
  const ordered = groupVideosByContentType(videos).flatMap(g => g.videos);

  return (
    <section>
      <div className="ed-cap">
        <span className="ed-cap__label">Highlights</span>
        <span className="ed-cap__hint">
          {videos.length} {videos.length === 1 ? 'video' : 'videos'}
        </span>
      </div>

      <div className="ed-pp__videos">
        {ordered.map(v => {
          const tag = videoTag(v);
          return (
            <div key={v.id} className="ed-pp__card ed-pp__video">
              {/* VideoEmbed renders its own thumbnail markup with no slot for
                  the content-type tag, so the tag is overlaid by this
                  positioned wrapper rather than passed in as a prop. */}
              <div className="ed-pp__video-media">
                <VideoEmbed url={v.video_url} meta={v.video_meta} compact />
                {tag && (
                  <span className={`ed-pp__video-tag ed-pp__video-tag--${tag.modifier}`}>
                    {tag.label}
                  </span>
                )}
              </div>
              <div className="ed-pp__video-meta">
                <div className="ed-pp__video-title">{videoTitle(v)}</div>
                {(v.context_label || v.clip_tag) && (
                  <div className="ed-pp__video-sub">
                    {[v.context_label, v.clip_tag].filter(Boolean).join(' · ')}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
